import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { AuthService } from '@gpi/lbl/app/data-access/auth';
import { ENVIRONMENT, IEnvironment } from '@gpi/lbl/shared/entity';
import { Observable } from 'rxjs';

@Injectable()
export class SezioneAnnoScolasticoPeriodoFormativoHeaderInterceptor
  implements HttpInterceptor {
  constructor(
    private authService: AuthService,
    @Inject(ENVIRONMENT)
    private environment: IEnvironment,
  ) { }

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler,
  ): Observable<HttpEvent<any>> {
    const apiUrl = this.environment.urls.api;
    const sezioneAnnoScolasticoPeriodoFormativo = this.authService.query.getValue()
      .sezioneAnnoScolasticoPeriodoFormativo;
    const sezioneAnnoScolasticoPeriodoFormativoImpersonificato = this.authService.query.getValue()
      .sezioneAnnoScolasticoPeriodoFormativoImpersonificato;

    const sezioneAnnoScolasticoPeriodoFormativoId = sezioneAnnoScolasticoPeriodoFormativoImpersonificato
      ? sezioneAnnoScolasticoPeriodoFormativoImpersonificato.id.toString()
      : sezioneAnnoScolasticoPeriodoFormativo
      ? sezioneAnnoScolasticoPeriodoFormativo.id.toString()
      : null;

    if (req.url.startsWith(apiUrl) && sezioneAnnoScolasticoPeriodoFormativoId) {
      req = req.clone({
        setHeaders: {
          sezioneAnnoScolasticoPeriodoFormativoId,
        },
      });
    }

    return next.handle(req);
  }
}
